const config = {
    urlApi: process.env.REACT_APP_URL_API,
    urlWeb: process.env.REACT_APP_URL_WEB,
    idUnidadFarmacia: process.env.REACT_APP_ID_UNIDAD_FARMACIA,
    idUnidadAdministracion: process.env.REACT_APP_ID_UNIDAD_ADMINISTRACION
}

export default config;